import React from "react";
import { Spinner } from "react-bootstrap";

type Props = {
  loadingText?: string;
  overlay?: boolean;
};

function PageSpinner({ loadingText = "Please wait...", overlay = true }: Props) {
  const baseStyle: React.CSSProperties = overlay
    ? {
        position: "fixed",
        inset: 0,
        background: "var(--surface-card)",
        zIndex: 9999,
      }
    : {
        minHeight: "60vh",
      };

  return (
    <div
      style={{
        ...baseStyle,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spinner animation="border" variant="primary" />
      <div style={{ marginTop: "16px", color: "var(--text-muted)", fontSize: "14px" }}>
        {loadingText}
      </div>
    </div>
  );
}

export default PageSpinner;
